import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { usePickupModals } from "@redotech/redo-customer-portal-shared/hooks/useReturnConfirmation/use-pickup-modals";
import { useTranslation } from "@redotech/redo-i18n";
import Calendar from "@redotech/redo-icons/calendar.svg";
import XClose from "@redotech/redo-icons/x-close.svg";
import { memo } from "react";

export const PickupButtons = memo(function PickupButtons({
  pickupModals,
}: {
  pickupModals: ReturnType<typeof usePickupModals>;
}) {
  const { t } = useTranslation();
  const { setRescheduleModalOpen, setCancelModalOpen } = pickupModals;

  return (
    <Flex flexDirection="row" gap="sm" grow={1} pt="xs">
      <RedoButton
        hierarchy="secondary"
        IconLeading={Calendar}
        onClick={() => setRescheduleModalOpen(true)}
        text={t("Reschedule pickup")}
      />
      <RedoButton
        hierarchy="secondary"
        IconLeading={XClose}
        onClick={() => setCancelModalOpen(true)}
        text={t("Cancel pickup")}
      />
    </Flex>
  );
});
